import React, {PropTypes} from 'react';
import Modal from '../../Modal';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import {workOrder} from "../api";
import {sort} from '../helper';

@inject('stationStore', 'workOrderStore')
@observer
export default class WorkOrderStationAdd extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view` : `/monitoring/work_order/tabular/${this.props.params.id}/view`;

  @observable selectedStation = [];

  componentWillMount() {
    const {stationStore, workOrderStore} = this.props;
    stationStore.items.length === 0 && stationStore.fetchItems();
    this.selectedStation = workOrderStore.workOrder.station ? workOrderStore.workOrder.station.map(item => +item.id) : [];
  }

  @action onAddStation = e => this.selectedStation.push(+e.target.value);
  @action onRemoveStation = id => this.selectedStation = this.selectedStation.filter(item => +item !== +id);

  onSave = () => {
    const {notify, router} = this.context;
    workOrder.station.save(this.props.params.work_order_id ? this.props.params.work_order_id : this.props.params.id, toJS(this.selectedStation)).then(res => {
      notify.success(res);
      router.push(this.slug)
    }).catch(notify.error)
  };

  render() {
    const {stationStore, workOrderStore} = this.props;
    let unselectedStation = this.selectedStation && stationStore.items.filter(item => {
      if(this.selectedStation.indexOf(+item.id) === -1) return item.id
    });

    return (
      <Modal slug={this.slug} title='Add/Remove Station'>
        <div>
          <select value="0" onChange={this.onAddStation} style={{width:'70%'}}>
            <option value="0">Add Station</option>
            {sort(unselectedStation).map((item, index) => (
              <option key={index} value={item.id}>{item.name}</option>
            ))}
          </select><br/><br/>
          <div className='DataTable'>
            <table>
              <thead>
              <tr>
                <th>Station</th>
                <th>{}</th>
              </tr>
              </thead>
              <tbody>
              {sort(this.selectedStation).map((item, i) => {
                const station = stationStore.findById(item);

                return <tr key={`work_order_station_${i}`} className="childRow" style={{height: '30px'}}>
                  <td>{station ? station.name : item}</td>
                  <td className='crudActions'><a onClick={() => this.onRemoveStation(item)}><i className='fa fa-remove'/></a></td>
                </tr>
              })}
              </tbody>
            </table>
            <div className="tableActions">
              <button className="button" onClick={this.onSave}>Save</button>
            </div>
          </div>
          <br/>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderStationAdd.js